/**
 * Decode HTML entities (e.g. `&amp;`, `&lt;`) in a server-supplied string into
 * their literal characters, for use in `{{ }}` TEXT interpolation only.
 *
 * SECURITY: the returned value is a decoded plain string. It MUST NOT be passed
 * to `v-html` / `innerHTML`. Text extraction via `textarea.value` is the
 * XSS-safe way to decode entities without re-introducing markup into the DOM.
 */
export function decodeHtml(input: string): string {
  if (!input) return '';
  const el = document.createElement('textarea');
  el.innerHTML = input;
  return el.value;
}
